import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-serif font-bold text-gray-800 mb-4">
              Restoration by Design
            </h3>
            <p className="text-gray-600 mb-4">
              Bringing new life to cherished furniture pieces with expert craftsmanship and care.
            </p>
            <p className="text-sm text-gray-500">
              Proudly Canadian owned and operated
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-gray-800 mb-4">Quick Links</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-gray-600 hover:text-rose-400 transition-colors">
                About Us
              </Link>
              <Link to="/furniture" className="text-gray-600 hover:text-rose-400 transition-colors">
                Our Furniture
              </Link>
              <Link to="/contact" className="text-gray-600 hover:text-rose-400 transition-colors">
                Contact Us
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-gray-800 mb-4">Contact Information</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-rose-400 mt-0.5 flex-shrink-0" />
                <p className="text-gray-600">
                  Unit 11 - 2500 Meadowpine Blvd.<br />
                  Mississauga, ON L5N 6C4
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-rose-400 flex-shrink-0" />
                <a href="tel:9056081876" className="text-gray-600 hover:text-rose-400 transition-colors">
                  (905) 608-1876
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-rose-400 flex-shrink-0" />
                <a href="mailto:info@restorationbydesign.ca" className="text-gray-600 hover:text-rose-400 transition-colors">
                  info@restorationbydesign.ca
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Restoration by Design. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
